module.exports = __webpack_public_path__ + "static/media/asignatura4.fcc195d6.png";